var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit / plus_circle_outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "coolicon",
    d: "M12 22.2142C6.47715 22.2142 2 17.737 2 12.2142C2 6.69132 6.47715 2.21417 12 2.21417C17.5228 2.21417 22 6.69132 22 12.2142C21.9939 17.7345 17.5203 22.2081 12 22.2142ZM4 12.3862C4.04732 16.7874 7.64111 20.3237 12.0425 20.3002C16.444 20.2764 19.9995 16.7017 19.9995 12.3002C19.9995 7.89868 16.444 4.32395 12.0425 4.30017C7.64111 4.27663 4.04732 7.81293 4 12.2142V12.3862ZM13 17.2142H11V13.2142H7V11.2142H11V7.21417H13V11.2142H17V13.2142H13V17.2142Z",
    fill: "#C4C4BC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircleOutline);
export default __webpack_public_path__ + "static/media/plus_circle_outline.e20be63f36c1c22f76e4453d7a7457ee.svg";
export { ForwardRef as ReactComponent };